import { MEASURE_NAMES, MEASURE_SCORES, SKILL_NAMES } from '../../constants/assessments';
import { GRADE } from '../../constants/enrollment';
import { LECTURA_INTERPRETATIONS } from '../../constants/interpretations';

export const INTERPRETATIONS_AT_RISK = [
    LECTURA_INTERPRETATIONS.WELL_BELOW_BENCHMARK,
    LECTURA_INTERPRETATIONS.BELOW_BENCHMARK,
];

export const GATING_RULES_AT_RISK = ['DISCONTINUE'];

export const REQUIRED_SKILLS_FOR_RECOMMENDATIONS = {
    [GRADE.KG]: [
        { skillName: SKILL_NAMES.NOMBRAR_LETRAS, measureName: MEASURE_NAMES.FNL },
        { skillName: SKILL_NAMES.SONIDOS_DE_LETRAS, measureName: MEASURE_NAMES.FSL },
        { skillName: SKILL_NAMES.DECODIFICATION, measureName: MEASURE_NAMES.LSS },
        { skillName: SKILL_NAMES.CONCIENCIA_FONOLOGICA, measureName: MEASURE_NAMES.FSS },
        {
            skillName: SKILL_NAMES.LECTURA_DE_PALABRAS,
            measureName: MEASURE_NAMES.FEP,
        },
    ],
    [GRADE.ONE]: [
        { skillName: SKILL_NAMES.NOMBRAR_LETRAS, measureName: MEASURE_NAMES.FNL },
        { skillName: SKILL_NAMES.SONIDOS_DE_LETRAS, measureName: MEASURE_NAMES.FSL },
        { skillName: SKILL_NAMES.DECODIFICATION, measureName: MEASURE_NAMES.LSS },
        { skillName: SKILL_NAMES.CONCIENCIA_FONOLOGICA, measureName: MEASURE_NAMES.FSS },
        {
            skillName: SKILL_NAMES.LECTURA_DE_PALABRAS,
            measureName: MEASURE_NAMES.FEP,
        },
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
    ],
    [GRADE.TWO]: [
        {
            skillName: SKILL_NAMES.LECTURA_DE_PALABRAS,
            measureName: MEASURE_NAMES.FEP,
        },
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
        { skillName: SKILL_NAMES.COMPRENSION_BASICA, measureName: MEASURE_NAMES.CP },
    ],
    [GRADE.THREE]: [
        {
            skillName: SKILL_NAMES.LECTURA_DE_PALABRAS,
            measureName: MEASURE_NAMES.FEP,
        },
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
        { skillName: SKILL_NAMES.COMPRENSION_BASICA, measureName: MEASURE_NAMES.CP },
    ],
    [GRADE.FOUR]: [
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
        { skillName: SKILL_NAMES.COMPRENSION_BASICA, measureName: MEASURE_NAMES.CP },
    ],
    [GRADE.FIVE]: [
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
        { skillName: SKILL_NAMES.COMPRENSION_BASICA, measureName: MEASURE_NAMES.CP },
    ],
    [GRADE.SIX]: [
        { skillName: SKILL_NAMES.FLUIDEZ_EN_LA_LECTURA, measureName: MEASURE_NAMES.FLO },
        { skillName: SKILL_NAMES.COMPRENSION_BASICA, measureName: MEASURE_NAMES.CP },
    ],
};

export default {
    [GRADE.KG]: [
        {
            atRisk: [MEASURE_SCORES.FSL],
            recommendedMeasures: [MEASURE_NAMES.FSL],
        },
        {
            atRisk: [MEASURE_SCORES.LSS],
            recommendedMeasures: [MEASURE_NAMES.LSS],
        },
        {
            atRisk: [MEASURE_SCORES.FSS],
            recommendedMeasures: [MEASURE_NAMES.FSS],
        },
        {
            atRisk: [MEASURE_SCORES.FEP],
            recommendedMeasures: [MEASURE_NAMES.FEP],
        },
    ],
    [GRADE.ONE]: [
        {
            atRisk: [MEASURE_SCORES.FSL],
            recommendedMeasures: [MEASURE_NAMES.FSL],
        },
        {
            atRisk: [MEASURE_SCORES.LSS],
            recommendedMeasures: [MEASURE_NAMES.LSS],
        },
        {
            atRisk: [MEASURE_SCORES.FSS],
            recommendedMeasures: [MEASURE_NAMES.FSS],
        },
        {
            atRisk: [MEASURE_SCORES.FEP],
            recommendedMeasures: [MEASURE_NAMES.FEP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
    ],
    [GRADE.TWO]: [
        {
            atRisk: [MEASURE_SCORES.FEP],
            recommendedMeasures: [MEASURE_NAMES.FEP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
        {
            atRisk: [MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_NAMES.CP],
        },
    ],
    [GRADE.THREE]: [
        {
            atRisk: [MEASURE_SCORES.FEP],
            recommendedMeasures: [MEASURE_NAMES.FEP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
        {
            atRisk: [MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_NAMES.CP],
        },
    ],
    [GRADE.FOUR]: [
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
        {
            atRisk: [MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_NAMES.CP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO, MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_SCORES.FLO, MEASURE_NAMES.CP],
        },
    ],
    [GRADE.FIVE]: [
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
        {
            atRisk: [MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_NAMES.CP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO, MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_SCORES.FLO, MEASURE_NAMES.CP],
        },
    ],
    [GRADE.SIX]: [
        {
            atRisk: [MEASURE_SCORES.FLO],
            recommendedMeasures: [MEASURE_NAMES.FLO],
        },
        {
            atRisk: [MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_NAMES.CP],
        },
        {
            atRisk: [MEASURE_SCORES.FLO, MEASURE_SCORES.CP],
            recommendedMeasures: [MEASURE_SCORES.FLO, MEASURE_NAMES.CP],
        },
    ],
};
